import React, { useState } from 'react';
import Sidebar from './Sidebar';
import AdminTopNav from './AdminTopNav';
import { Box } from '@mui/material';

const Layout = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <Sidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          transition: 'margin-left 0.3s ease',
          ml: { xs: 0, md: isCollapsed ? '80px' : '280px' }, // Sidebar width match
          width: `calc(100% - ${isCollapsed ? '80px' : '280px'})`,
        }}
      >
        <AdminTopNav isCollapsed={isCollapsed} />
        <Box
          sx={{
            pt: '80px', // Space for fixed top nav
            p: 3,
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
